import React, { SetStateAction } from 'react';

import { Badge } from '@protonradio/proton-ui';
import history from 'config/history';
import { ConfirmationModalState, LabelSubscription } from './LabelSubscribersContext';
import { ArchiveAccessMutationApi } from './useArchiveAccessMutations';
import { GetLabelAndViewerQuery } from 'gql/graphql';

export default function buildLabelSubscriberActions(
  label: NonNullable<GetLabelAndViewerQuery['label']>,
  subscription: LabelSubscription,
  archiveAccess: ArchiveAccessMutationApi,
  setConfirmationModal: React.Dispatch<SetStateAction<ConfirmationModalState>>
) {
  const artist = subscription.node;

  return [
    !subscription.hasArchiveAccess && {
      name: 'Grant Archive Access',
      icon: 'icon-delete.svg',
      testId: LABEL_SUBSCRIBER_ACTION_TEST_IDS.GRANT_ARCHIVE_ACCESS_BUTTON,
      onClick: ({ close }: { close?: () => void }) => {
        setConfirmationModal({ type: 'archive-access', artist });
        if (close) close();
      }
    },
    subscription.hasArchiveAccess && [
      {
        Component: ({ dropdownMenu }) => {
          if (dropdownMenu) return null;

          const archiveExpiration = subscription.archiveAccessExpiresAt
            ? new Date(subscription.archiveAccessExpiresAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
              })
            : null;
          return (
            <div className="mt-1 mb-1 ml-2">
              <Badge>Archive Access • Until {archiveExpiration}</Badge>
            </div>
          );
        }
      },
      {
        name: 'Renew Archive Access',
        icon: 'icon-delete.svg',
        testId: LABEL_SUBSCRIBER_ACTION_TEST_IDS.RENEW_ARCHIVE_ACCESS_BUTTON,
        onClick: ({ close }: { close?: () => void }) => {
          void archiveAccess('renew', label.id, artist!.id);
          if (close) close();
        }
      },
      {
        name: 'Revoke Archive Access',
        danger: true,
        icon: 'icon-delete.svg',
        testId: LABEL_SUBSCRIBER_ACTION_TEST_IDS.REVOKE_ARCHIVE_ACCESS_BUTTON,
        onClick: ({ close }: { close?: () => void }) => {
          void archiveAccess('revoke', label.id, artist!.id);
          if (close) close();
        }
      }
    ],
    { divider: true },
    {
      name: 'Remove Subscriber',
      danger: true,
      icon: 'icon-delete.svg',
      testId: LABEL_SUBSCRIBER_ACTION_TEST_IDS.REMOVE_SUBSCRIBER_BUTTON,
      onClick: ({ close }: { close: () => void }) => {
        // NOTE: We could refactor onConfirm, but I think this is better until we
        // rebuild our action menus / dropdown menu apis to be better
        setConfirmationModal({ type: 'remove-subscriber', artist });
        close();
      }
    },
    {
      name: 'View Artist',
      icon: 'icon-artist--light.svg',
      onClick: () => history.push(artist!.slug!)
    },
    {
      name: 'View Feedback',
      icon: 'icon-artist--light.svg',
      onClick: () => history.push(`${artist!.slug}/feedback`)
    }
  ]
    .flat()
    .filter(Boolean);
}

export const LABEL_SUBSCRIBER_ACTION_TEST_IDS = {
  GRANT_ARCHIVE_ACCESS_BUTTON: 'grant-archive-access-button',
  RENEW_ARCHIVE_ACCESS_BUTTON: 'renew-archive-access-button',
  REVOKE_ARCHIVE_ACCESS_BUTTON: 'revoke-archive-access-button',
  REMOVE_SUBSCRIBER_BUTTON: 'remove-subscriber-button'
};
